import React from 'react'

const FeedbackModalContext = React.createContext({})

const FeedbackModalProvider = props => {
  const [isOpenFeedbackModal, setIsOpenFeedbackModal] = React.useState(true)
  const [feedbackConfigs, setFeedbackConfigs] = React.useState(null)

  const value = React.useMemo(
    () => ({
      feedbackConfigs,
      setFeedbackConfigs,
      isOpenFeedbackModal,
      setIsOpenFeedbackModal,
    }),
    [isOpenFeedbackModal, feedbackConfigs],
  )

  return (
    <FeedbackModalContext.Provider value={value}>
      {props.children}
    </FeedbackModalContext.Provider>
  )
}

function useFeedbackModalContext() {
  const context = React.useContext(FeedbackModalContext)

  if (!context) {
    throw new Error(
      'useFeedbackModalContext must be inside FeedbackModalProvider',
    )
  }

  return context
}

export { FeedbackModalProvider, useFeedbackModalContext }
